import { GUIDHelper } from '../../helpers';

type UserConfig = {
    history_black_britain: boolean;
}
export class User {
    id: number;
    name: string;
    email: string;
    product: string;
    password: string;
    retypepassword: string;
    token: string;
    refreshToken: string;
    invitationCode: string;
    activation_code: string;
    session_guid: string;
    hr: number;
    kind: string;
    played_a_game_before: number;
    config: UserConfig;

    client_id: number
    client_name: string

    constructor() {
        this.id = 0;
        this.name = '';
        this.email = '';
        this.password = '';
        this.session_guid = '';
        this.retypepassword = '';
        this.token = '';
        this.invitationCode = '';
        this.activation_code = '';
        this.played_a_game_before = 0;
    }

    static makeid(size = 5) {
        const guid = new GUIDHelper();
        return guid.toString();
    }
}
